import Popup from "../../utils/popup";
import CartShort from "../../utils/cart-short";

class Prepaidcard {
    constructor() {
        this.cartShort = new CartShort();
    }

    events() {
        const _this = this;
        $('input[name="karty-przedplacone-type"]').change(function () {
            let rodzajKarty = parseInt($(this).val());
            if (rodzajKarty === rodzajObecnaKarta) {
                $('.row-karty-przedplacone-prepaid_card_number').removeClass('d-none').addClass('d-block');
                $('#karty-przedplacone-prepaid_card_number').prop('disabled', false);
                $('#karty-przedplacone-submit').html(translates.doladuj_karte);
            } else {
                $('.row-karty-przedplacone-prepaid_card_number').removeClass('d-block').addClass('d-none');
                $('#karty-przedplacone-prepaid_card_number').prop('disabled', true);
                $('#karty-przedplacone-submit').html(translates.zamow_karte);
            }

            _this.savePageDataInSession();
        });

        $(".prepaidcard__amount-items .prepaidcard__amount-value").off('click').on("click", function (e) {
            //$('.prepaid_card_other_amount').hide();
            $("#prepaidcard-kwota_inna").val("").trigger("keyup");
            $(".prepaidcard__amount-items .prepaidcard__amount-value").removeClass(
                "prepaidcard__amount-value--selected"
            );

            $(this).addClass("prepaidcard__amount-value--selected");

            if ($(this).hasClass("prepaidcard__amount-value--other")) {
                $("#karty-przedplacone-topup_amount").val('');
                $('.prepaid_card_other_amount').removeClass('d-none').addClass('d-block');
                $('#karty-przedplacone-inna_kwota').prop('disabled', false);
            } else {
                $('.prepaid_card_other_amount').removeClass('d-block').addClass('d-none');
                $("#karty-przedplacone-topup_amount").val($(this).data("kwota"));
                $('#karty-przedplacone-inna_kwota').prop('disabled', true);
            }

            _this.savePageDataInSession();
        });

        $('#karty-przedplacone-prepaid_card_number').on('blur', function () {
            _this.checkPrepaidCard($(this).val());
        });

        $('#karty-przedplacone-inna_kwota').on('blur', function () {
            $("#karty-przedplacone-topup_amount").val($(this).val());
            _this.savePageDataInSession();
        });

        if($('.prepaidcard__amount-value.prepaidcard__amount-value--selected').length === 0){
            $($('.prepaidcard__amount-value')[0]).trigger('click');
        }
    }

    checkPrepaidCard(card_number) {
        $.ajax({
            url: '/rezerwacja/karty-przedplacone.html',
            method: 'get',
            data: {
                ajax: 'checkPrepaidCard',
                prepaid_card_number: card_number
            },
            success: function (result) {
                if (result && result.status === 'complete') {

                } else {
                    let popup = new Popup(
                        result.message || translates.sprawdzanie_karty_blad
                    );
                    popup.showPopup();

                    if ($('#karty-przedplacone-prepaid_card_number').hasClass('is-invalid') === false) {
                        $('#karty-przedplacone-prepaid_card_number').removeClass('is-valid').addClass('is-invalid');
                    }
                }
            },
            error: function (xhr, status, error) {
                console.error(status);
                console.error(error);
            }
        });
    }

    savePageDataInSession() {
        $.ajax({
            url: '/rezerwacja/karty-przedplacone.html',
            method: 'get',
            data: {
                ajax: 'savePageDataInSession',
                topupType: $('[name="karty-przedplacone-type"]:checked').val(),
                preselectedAmount: $('.prepaidcard__amount-value.prepaidcard__amount-value--selected').hasClass('prepaidcard__amount-value--other') ? 'other' : $('.prepaidcard__amount-value.prepaidcard__amount-value--selected').data('kwota'),
                otherAmount: $('#karty-przedplacone-inna_kwota').is(':visible') ? $('#karty-przedplacone-inna_kwota').val() : '',
                prepaid_card_number: $('#karty-przedplacone-prepaid_card_number').is(':visible') ? $('#karty-przedplacone-prepaid_card_number').val() : ''
            },
            success: function (result) {
                console.log(result);
                if (result && result.status === 'complete') {

                } else {
                    let popup = new Popup(
                        result.message || translates.zapis_danych_blad
                    );
                    popup.showPopup();
                }
            },
            error: function (xhr, status, error) {
                console.error(status);
                console.error(error);
            }
        });
    }

    init() {
        if (parseInt($('input[name="karty-przedplacone-type"]:checked').val()) === rodzajObecnaKarta) {
            $('.row-karty-przedplacone-prepaid_card_number').removeClass('d-none').addClass('d-block');
            $('#karty-przedplacone-prepaid_card_number').prop('disabled', false);
        }

        if ($('input[name="karty-przedplacone-topup_amount"]:checked').val() === 'other') {
            $('.prepaid_card_other_amount').show();
            $('#karty-przedplacone-inna_kwota').prop('disabled', false);
        }


        this.events();
    }
}

export default Prepaidcard;
